import { useState } from "react";
import { Plus, MessageCircle } from "lucide-react";
import { FAQS, wa } from "@/constants/content";

/**
 * Real ThemeStudios FAQs — reused on Home + Contact + Service pages.
 */
export default function FAQ({ compact = false }) {
  const [open, setOpen] = useState(0);

  return (
    <section className={`px-6 md:px-12 max-w-[1200px] mx-auto ${compact ? "" : "mt-24 md:mt-32"}`}>
      <div className="flex items-end justify-between mb-10 flex-wrap gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-[#e03c31] font-bold mb-5">
            ✱ Frequently Asked Questions
          </p>
          <h2 className="font-cabinet text-3xl md:text-5xl font-black tracking-tight">
            Short answers before you start the brief.
          </h2>
          <p className="text-zinc-400 mt-4 max-w-2xl">
            These are the common questions businesses ask before choosing from the new service,
            branding, ads, and monthly support ladder.
          </p>
        </div>
        <a
          href={wa("package")}
          target="_blank"
          rel="noreferrer"
          data-testid="faq-whatsapp"
          className="btn-magnetic btn-ghost"
        >
          <MessageCircle size={16} /> Talk on WhatsApp
        </a>
      </div>

      <div className="space-y-3">
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              data-testid={`faq-item-${i + 1}`}
              className={`bg-[#0a0a0c] border rounded-2xl transition-colors ${
                isOpen ? "border-[#e03c31]/40" : "border-white/5"
              }`}
            >
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full px-6 md:px-8 py-5 md:py-6 flex items-center justify-between text-left"
                aria-expanded={isOpen}
              >
                <span className="font-cabinet text-lg md:text-xl font-bold pr-4">{f.q}</span>
                <Plus
                  size={20}
                  className={`text-[#e03c31] shrink-0 transition-transform duration-300 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                />
              </button>
              <div
                className={`grid transition-all duration-500 ease-out ${
                  isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-zinc-400 text-sm md:text-base leading-relaxed px-6 md:px-8 pb-6">
                    {f.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
